export default __webpack_public_path__ + "static/media/crudspace.ca277b3c.jpeg";